export class AuthRequestError extends Error {
	constructor(status, message, payload) {
		super(message);
		this.name = "AuthRequestError";
		this.status = status;
		this.payload = payload;
	}
}

function serverMessage(payload) {
	const messages = payload?._server_messages;
	if (!messages) return String(payload?.message || payload?.exc_type || "");
	try {
		const parsed = JSON.parse(messages);
		return parsed
			.map((entry) => {
				try {
					return JSON.parse(entry).message;
				} catch (_error) {
					return entry;
				}
			})
			.filter(Boolean)
			.join(" ");
	} catch (_error) {
		return "";
	}
}

export async function post(url, values) {
	const body = new URLSearchParams();
	Object.entries(values || {}).forEach(([key, value]) => {
		if (value !== undefined && value !== null) body.set(key, String(value));
	});
	const response = await fetch(url, {
		method: "POST",
		credentials: "same-origin",
		headers: {
			Accept: "application/json",
			"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
			"X-Frappe-CSRF-Token": window.frappe?.csrf_token || "",
		},
		body,
	});
	let payload = {};
	try {
		payload = await response.json();
	} catch (_error) {
		// Consumers map malformed responses to their localized generic message.
	}
	if (!response.ok) {
		throw new AuthRequestError(response.status, serverMessage(payload), payload);
	}
	return payload;
}

export function methodResult(payload) {
	return payload?.message ?? payload;
}
